import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { green, red } from '@mui/material/colors';

const MAIN_COLOR = '#5195F3';
const SECONDARY_COLOR = '#5195F3';
const WHITE_COLOR = '#ffffff';
const TEXT_COLOR = '#1D1D1F';
const BASE_COLOR = '#F5F5F7';

let theme = createTheme({
    palette: {
        primary: {
            main: MAIN_COLOR,
        },
        secondary: {
            main: SECONDARY_COLOR,
        },
        green: {
            main: green[500],
        },
        red: {
            main: red[500],
        },
        indicator: {
            green: '#47ba80',
            red: '#f46464',
            yellow: '#f4c04e',
            disable: '#eaeaea',
        },
        button: {
            main: '#CDAC89',
            borderMain: '2px solid #CDAC89',
            darkRed: '#cd4949',
            yellow: '#ffcb58',
            green: '#47ba80'
        },
        bottomIconColor: WHITE_COLOR,
        selectedBottomIconColor: 'linear-gradient(90deg, #55D3FF,#684EFF)',
        backgroundColor: BASE_COLOR,
        white: WHITE_COLOR,
        dialogContentBg: '#0D184F',
        inputIconColor: MAIN_COLOR,
        textColor: TEXT_COLOR
    },
    components: {
        // Name of the component
        MuiBottomNavigation: {
            styleOverrides: {
                // Name of the slot
                root: {
                    // background: 'linear-gradient(180deg, #324499 8.95%, #06071B 91.05%)',
                    background: '#1a1f49',
                    // height:80,
                    // paddingBottom:15,
                },
            },
        },

        MuiButton: {
            styleOverrides: {
                outlined:{
                    border: `2px solid ${MAIN_COLOR}`,
                    borderRadius: 50,
                    '&:hover': {
                        backgroundColor: 'transparent',
                        border: `2px solid ${MAIN_COLOR}`,
                    },
                },
                contained: {
                    padding:'12px 15px',
                    borderRadius: 10,
                    minWidth: 100
                }
            }
        },

        MuiAppBar: {
            styleOverrides: {
                root: {
                    background: '#FDFEFF',
                    boxShadow: 'none',
                    color:'#222'
                    // backgroundImage:'url(../images/public/header.png)',
                    // backgroundRepeat:'no-repeat',
                    // backgroundSize:'cover',
                    // width:'100%',
                    // backgroundPosition:'center top'
                },
            },
        },
      
        MuiAccordion: {
            styleOverrides: {
                root: {
                    backgroundColor: "transparent",
                    boxShadow:'none',
                    ":before": {
                        backgroundColor: "transparent"
                    },
                    '&.Mui-expanded':{
                        margin: 0
                    }
                }
            }
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    padding:0,
                    color: '#fff',
                    '&.Mui-expanded':{
                        minHeight: 40
                    }
                },
                content: {
                    margin: 0,
                     '&.Mui-expanded':{
                        margin: 0
                    }
                },
                expandIconWrapper:{
                    color:'#fff',
                    '& .Mui-expanded':{
                        transform: 'rotate(90deg)'
                    }
                }
            }
        },

        MuiDialog: {
            styleOverrides: {
                paper: {
                    backgroundColor: 'transparent',
                    // background: 'linear-gradient(194deg, rgba(255, 255, 255, 0.41) 21.13%, rgba(194, 194, 194, 0.17) 43.89%, rgba(197, 197, 197, 0.17) 67.7%, rgba(241, 241, 241, 0.35) 81.29%)', 
                    // gap: 16,
                    // borderRadius: 12,
                    // alignItems: 'center',
                    // width: 320,
                    // maxWidth: '85%',
                    boxShadow:'none',
                },
                backdrop: {
                    backdropFilter: 'blur(2px)',
                    backgroundColor: '#000000b5'
                }
            },
        },

        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontWeight:500
                }
            }
        },

        MuiFilledInput: {
            styleOverrides: {
                root: {
                    background: '#F3F4F6',
                    borderRadius:10,
                    '&::before': {
                        borderBottom: 'none', // Example override
                    },
                    '&::after': {
                        borderBottom: '2px solid #5195F3', // Example override
                    },
                },
                input: {
                    color: TEXT_COLOR
                }
            }
        },

        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    backgroundColor: '#0000000d',
                    borderRadius: 10,
                    height: 20,
                },
                bar1Determinate: {
                    borderRadius: 10,
                }
            }
        },
        MuiCssBaseline: {
            styleOverrides: (themeParam) => `
              & .MuiBottomNavigation-root &.Mui-selected {
                color: ${themeParam.palette.selectedBottomIconColor} !important;
              },
              & .MuiTab-root.Mui-selected{
                color: ${themeParam.palette.selectedBottomIconColor} !important;
                border-top: 2px solid ${themeParam.palette.selectedBottomIconColor};
                border-bottom: 2px solid ${themeParam.palette.selectedBottomIconColor};
              },
            `,
        },
    }
});

theme = responsiveFontSizes(theme);

export default theme;